import { Pessoa } from './pessoa';

export class Gestor {
    public telefone: string;
    constructor(
        public gestorId: number,
        public gestorGuid: string,
        public pessoaId: number,
        public pessoa: Pessoa,
        public email: string
    ) { }
}
